import { gql } from '@apollo/client';

export const GET_CUSTOMERS_PAGINATED = gql`
  query CustomersPaginated($limit: Int!, $offset: Int!, $searchString: String) {
    customersPaginated(limit: $limit, offset: $offset, searchString: $searchString) {
      totalRecords
      customers {
        clie_id
        clie_nombre
        clie_ap
        clie_am
        clie_cp
        clie_rfc
        clie_regimen_fiscal
        clie_correo
        clie_tel
        clie_activo
        clie_tipo
      }
    }
  }
`;
